module.exports = __webpack_public_path__ + "static/img/HOME-4.139a8f70.jpg";